import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { getLocale } from 'selectors/user';
import { MenuContainer } from 'components/Menu/styles';
import { Item, StyledLink, Details, Name, MenuIndicator, IndicatorIcon } from 'components/BrowseLink/styles';
import ChevronForward from 'components/Icons/ChevronForward';
import image from 'utils/image';
import addCssPrefixTo from 'utils/addCssPrefixTo';
import { GuestDirectorySection } from '../types';

interface Props {
  sections: GuestDirectorySection[];
  menuSlug: string;
  selectedSectionSlug?: string;
}

const StyledItem = styled(Item)`
  min-height: 400px;
  height: 400px;
`;

const GuestDirectorySectionSelection: React.FC<Props> = ({ sections, menuSlug, selectedSectionSlug }) => {
  const currentLocale = useSelector(getLocale);

  const sectionHasImages = sections.some(section => section.images && section.images.length > 0);
  const indicatorIconProps = { fill: '#bbbbbb', width: '21px', height: '21px' };

  return (
    <MenuContainer isGridView={false}>
      {sections.map(section => {
        const sectionName = section.translations?.[currentLocale]?.name || section.name || '';
        const imagePath = section.images?.[0]?.path;
        const isSelected = section.slug === selectedSectionSlug;

        return (
          <StyledItem
            key={section.id}
            hasImage={!!imagePath}
            listView={!sectionHasImages}
            filtered={false}
            style={imagePath && { backgroundImage: `url(${image(imagePath, { height: 700 })})` }}
            className={addCssPrefixTo(isSelected ? 'SECTION_LINK_ACTIVE' : 'SECTION_LINK')}
          >
            <StyledLink
              image={imagePath ? 1 : 0}
              to={{
                pathname: `/guest-directory/menu/${menuSlug}/section/${section.slug}`,
                state: { transition: 'Forward' },
              }}
            >
              <Details hasImage={!!imagePath}>
                <span>
                  <Name>{sectionName}</Name>
                </span>
              </Details>
              <MenuIndicator hasImage={!!imagePath}>
                <IndicatorIcon>
                  <ChevronForward {...indicatorIconProps} />
                </IndicatorIcon>
              </MenuIndicator>
            </StyledLink>
          </StyledItem>
        );
      })}
    </MenuContainer>
  );
};

export default GuestDirectorySectionSelection;
